import type { FunctionComponent } from "react";
import Highlighter from "react-highlight-words";
import { Text } from "@kanda-libs/ks-design-library";
import { HIGHLIGHT_PROPS } from "components/job/JobTable/JobIds/constants";
import useJobIdsProps from "components/job/JobTable/JobIds/useJobIdsProps";

export interface JobIdsProps {
  id: string;
  reference: string;
}

const JobIds: FunctionComponent<JobIdsProps> = function ({ id, reference }) {
  const { searchWords } = useJobIdsProps();

  return (
    <div className="flex flex-col">
      <div className="flex flex-row">
        <Text text="Job ID:" className="text-12-18-em min-w-14" />
        <Highlighter
          {...HIGHLIGHT_PROPS}
          searchWords={searchWords}
          textToHighlight={id || ""}
          className="text-12-18"
        />
      </div>
      <div className="flex flex-row">
        <Text text="Loan ID:" className="text-12-18-em min-w-14" />
        <Highlighter
          {...HIGHLIGHT_PROPS}
          searchWords={searchWords}
          textToHighlight={reference || ""}
          className="text-12-18"
        />
      </div>
    </div>
  );
};

export default JobIds;
